import React from "react";
import "../styles/App.css";
import img1 from "../components/images/profile.jpg";
import allumin from "./images/allumini.jpg";
import gcp from "./images/gcp1.jpg";

function About() {
  return (
    <section className="about" id="about">
      <div className="about-content">
       
        <p className="summary">
          <strong>About:</strong> <br />
          Sarthak is an Experienced Fullstack Developer with a demonstrated
          history of working professionally for over 1 year. and passed out B.E
          in the recent year 2023 in field of Computer Science and Engineering,
          Who is Passionate about building Software and Web Applications that
          have a material impact on real world problems. Skilled in Java and Web
          Development
          <br />
          <br />
          <strong>Profile Summary:</strong> <br />
          • 1 year of full-time experience in Fullstack Development <br />
          • 1+ year of internship experience <br />
          • Strong interest in building innovative and impactful projects <br />
          • Dedicated and motivated B.E. graduate in Computer Science
          Engineering
          <br />
          <br />
          <strong>Objective</strong> <br />
          I'm looking for a challenging role where I can be a valuable team
          member, share meaningful ideas, and contribute quality work in a
          growth-oriented environment — both for myself and the organization.
        </p>

        <img src={img1} alt="Sarthak Bhojane" className="profile-pic" loading="lazy" />

        <div className="rotated-container">
          <div className="rotated-block left">
            <img src={allumin} alt="Allumin not available" loading="lazy" />
            <h4>
              Honored to receive award from Principal of P. R. Pote College of
              Engineering and Management, Amravati
            </h4>
          </div>

          <div className="rotated-block right">
            <img src={gcp} alt="GCP not available" loading="lazy" />
            <h4>Thrilled to attend Google Cloud Program</h4>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
